<div class="modal-login">
  <div class="leftContent">
    <div class="logo wi8">
      <img [src]="logoPath" alt="VeriKlick Logo" class="img-fluid" />
    </div>
    <div class="text">
      <!-- TODO New Changes for now  -->
      <!-- {{ HeadingText }}<br> -->
      <div [innerHTML]="ContentText"></div>
    </div>
  </div>
</div>
